/**
 *
 * @param size - file size in bytes
 * @returns - get file size in MB
 */
export function convertBytesToMb(size: number): number {
  return size / (1000 * 1000);
}
